<!--
 * @Author: xsong
 * @Date: 2022-05-16 09:51:15
 * @LastEditTime: 2022-05-17 14:41:22
 * @LastEditors: xsong
 * @Description: 
 * @FilePath: /vue-modv-admin-cp/src/@core/components/common/BasicScrollTable.vue
-->
<template>
  <el-table
    :ref="refs"
    v-loading="tableLoading"
    v-el-table-infinite-scroll="loadScroll"
    :class="{ 'box-shadow': shadow }"
    :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    width="100%"
    :data="data"
    :border="border"
    :highlight-current-row="highlight"
    element-loading-background="rgba(0, 0, 0, 0.3)"
    element-loading-spinner="el-icon-loading"
    element-loading-text="加载中..."
    :cell-class-name="cellClassName"
    :row-class-name="rowClassName"
    @selection-change="$emit('selectionChange', $event)"
    @current-change="$emit('currentSelectionChange', $event)"
    @sort-change="onSort"
    @row-click="onClick"
  >
    <slot />
  </el-table>
</template>

<script>
export default {
  name: 'BasicScrollTable',
  props: {
    refs: {
      type: [String, Boolean],
      default: function() {
        return 'table'
      }
    },
    height: {
      type: [Number, String],
      default: 200
    },
    data: {
      type: Array,
      default: function() {
        return []
      }
    },
    tableLoading: Boolean,
    rowClassName: {
      type: Function,
      default: function() {
        return ''
      }
    },
    cellClassName: {
      type: Function,
      default: function() {
        return ''
      }
    },
    shadow: {
      type: Boolean,
      default: true
    },
    border: {
      type: [String, Boolean],
      default: false
    },
    multiple: {
      type: [String, Boolean],
      default: true
    },
    highlight: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      multipleSelection: []
    }
  },
  methods: {
    edit(row, index) {
      row.iseditor = true
    },
    save(row, index) {
      row.iseditor = false
    },
    changeOrder(column) {},
    onSort({ column, prop, order }) {
      this.$emit('sortChange', { column, prop, order })
    },
    // 下拉查询
    loadScroll() {
      this.$emit('loadScroll')
    },
    onClick(row) {
      if (this.multiple) {
        this.$refs[this.refs].toggleRowSelection(row)
      }
      this.$emit('row-click', row)
    },
    toggleRowSelection(rows) {
      this.$nextTick(() => {
        if (rows) {
          rows.forEach(row => {
            this.$refs[this.refs].toggleRowSelection(row, true)
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.el-table {
  flex: 1;
  width: 99.9% !important;
}
.warning-row {
  background: oldlace !important;
}

.success-row {
  background: #f0f9eb !important;
}
.warning-cell {
  color: #c32823;
}

.success-cell {
  color: #78af96;
}
</style>
